export const Colors = {
    primary: '#000000',
    secondary: '#5B69B7',
}